import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useFormikContext } from "formik";
import withAuth from "../../../../../../../Hoc/withAuth";
import { Skeleton } from "@mui/material";

const SelectClient = ({ name, user }) => {
  const { values, setFieldValue } = useFormikContext();

  const token = user.token;
  const config = { headers: { Authorization: `Bearer ${token}` } };

  const getClients = useQuery({
    queryKey: ["getClients"],
    queryFn: async () => {
      const response = await axios(
        `${process.env.REACT_APP_API_URL}/callCentre/clients`,
        config
      );

      return response.data;
    },
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return (
    <Box sx={{ minWidth: 120 }}>
      {getClients.isLoading ? (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={56}
          animation="wave"
          sx={{ borderRadius: 1, marginTop: 1, marginBottom: 1 }}
        />
      ) : (
        <FormControl fullWidth>
          <InputLabel id="select-client-label">Select Client</InputLabel>
          <Select
            labelId="select-client-label"
            id="select-client"
            value={values[name] || ""}
            label="Select Client"
            onChange={(event) => {
              setFieldValue(name, event.target.value);
            }}
          >
            {getClients?.data?.data.map((client) => (
              <MenuItem key={client.id} value={client.name}>
                {client.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default withAuth(SelectClient);
